'use client';

import ControlledButton from '@umodeapporg/ui/components/Form/ControlledButton';
import LinkButton from '@umodeapporg/ui/components/Navigation/LinkButton';
import { MaterialSymbol } from '@umodeapporg/ui/components/UI/MaterialSymbol';
import { useTranslation } from 'react-i18next';

/** The `texto` is the prompt sent to the agent; the visible label comes from `agente.atalhos.<key>`. */
const ATALHOS = [
  { key: 'carteira', texto: 'resumo da carteira' },
  { key: 'fila', texto: 'ver fila' },
  { key: 'historico', texto: 'historico do dia' },
  { key: 'implantacao', texto: 'o que falta validar' },
  { key: 'config', texto: 'ver configuracao' },
] as const;

/**
 * Registrar um apontamento e a tela que faz, nao conversa: este atalho ABRE
 * Apontamento > Registrar em vez de mandar uma frase para o agente.
 */
const APONTAR_PATH = '/apontamento?activeTab=registrar';

interface IAgenteAtalhosProps {
  onAtalho: (texto: string) => Promise<void>;
  /** Chamado quando o atalho sai do agente para uma tela, para o painel nao ficar aberto por cima. */
  onNavegar?: () => void;
  disabled?: boolean;
}

export function AgenteAtalhos({ onAtalho, onNavegar, disabled = false }: IAgenteAtalhosProps) {
  const { t } = useTranslation('common');

  return (
    <div className="flex w-full flex-col gap-2">
      <p className="text-xs font-medium uppercase tracking-wide text-foreground-subtle">{t('agente.atalhos.titulo')}</p>
      {ATALHOS.map((atalho) => (
        <ControlledButton
          key={atalho.key}
          variant="outlined"
          tone="neutral"
          size="sm"
          fullWidth
          disabled={disabled}
          className="justify-start normal-case"
          onClick={() => onAtalho(atalho.texto)}
        >
          {t(`agente.atalhos.${atalho.key}`)}
        </ControlledButton>
      ))}

      <LinkButton
        href={APONTAR_PATH}
        variant="outlined"
        tone="neutral"
        size="sm"
        fullWidth
        disabled={disabled}
        className="justify-start normal-case"
        onClick={onNavegar}
      >
        <MaterialSymbol icon="edit_note" size={16} className="shrink-0" />
        {t('agente.atalhos.apontar')}
      </LinkButton>
    </div>
  );
}
